export enum CalculationCheckboxMode {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}
